export class ProductInfo {
  ProductID: number
  ProductCode: string
  ProductName: string
  ProductDescription: string
  ProductUOM: string
  ProductUOMName: string
  ProductBV: number
  ProductPrice: number
  ProductType: string
  ProductTypeName: string
  ProductCategory: string
  ProductCategoryName: string
  ProductGroup: string
  ProductGroupName: string
  ProductUseVatFlag: string
  ProductVat: number
  ProductLicensePlate: string
  ProductChassisNo: string
  ProductSerialNo: string
  ProductCreateDate: string
  ProductCreateBy: string
  ProductCreateByName: string
  ProductUpdateDate: string
  ProductUpdateBy: string
  ProductUpdateByName: string
  ProductFlagDelete: string
  ProductAmount: number
  ProductNetAmount: number
  ProductProfit: number
  rowFetch: number
  rowOFFSet: number
  itemTotal: number
}
